import { render, staticRenderFns } from "./article-small.vue?vue&type=template&id=d52d4958&scoped=true&"
import script from "./article-small.vue?vue&type=script&lang=js&"
export * from "./article-small.vue?vue&type=script&lang=js&"
import style0 from "./article-small.vue?vue&type=style&index=0&id=d52d4958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52d4958",
  null
  
)

export default component.exports